import {Form} from 'antd';
import React, {useContext, useEffect, useState} from 'react';

import {detectAutoDetect} from '../../../../constants/Common';
import SelectedCountryContext from '../../../../pages/configurator/orgFacility/Constants/SelectedCountryContext';
import {APITypeEnum} from '../../../../services/interface/tableAPIType';
import machineDetails from '../../../../services/modules/IP/machineAPI';
import deviceFuelAPI from '../../../../services/modules/JSON/deviceFuel';
import deviceTypeAPI from '../../../../services/modules/JSON/deviceType';
import useJSONStore from '../../../../store/StaticJson/jsonStore';
import FuelForm from '../../../Forms/FuelForm';
import Loader from '../../../Loader/Loader';
import {IComponentProps} from '../../Common/perquisiteMaster';

const FuelBills: React.FC<IComponentProps> = ({
  record,
  caForm,
  onFinishFailed,
  onValuesChange,
  onSubmit
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const {efdbData, facilityId, selectedYear} = useContext(
    SelectedCountryContext
  );
  const year = record?.year ?? selectedYear;
  const facility = record?.facility ?? facilityId;
  const facilityEfdb = efdbData?.[year]?.find(
    (i: any) => i.facilityId === facility
  );
  const initialValues = {
    facility: record?.facility,
    year: record?.year
  };

  useEffect(() => {
    Promise.all([
      record?.referenceRecordId &&
        machineDetails(APITypeEnum.GET_ONE, {}, record?.referenceRecordId),
      deviceFuelAPI(),
      deviceTypeAPI()
    ])
      .then(([res1]) => {
        if (res1?.data?.isDeleted === false) {
          caForm.setFieldsValue(res1?.data);
          onValuesChange(true);
        } else {
          const fData: any = record?.fields ?? undefined;

          let fuelTypeUsed = '';

          const deviceFuel = useJSONStore.getState().deviceFuel;

          if (deviceFuel?.length > 0) {
            const res = deviceFuel.find((item) => {
              const fuelUsed = fData?.fuelUsed?.toLowerCase();
              const words = item.label
                ?.toLowerCase()
                ?.replace(/[()]/g, '') // remove brackets
                ?.split(/[\s\\/-]+/); // split by space, /,

              return (
                words?.includes(fuelUsed) &&
                item?.dbName === facilityEfdb?.scope1
              );
            });

            fuelTypeUsed = res?.value;
          }

          const customFromData: any = {
            _id: '',
            facility: record?.facility,
            timeFrameData: fData?.timeFrameData ?? [],
            fuelUsed: fuelTypeUsed,
            year: record?.year,
            status: 'ready_for_review',
            comment: ''
          };

          caForm.setFieldsValue(customFromData);
        }
      })
      .catch(() => {
        setIsLoading(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return isLoading ? (
    <Loader />
  ) : (
    <Form
      form={caForm}
      onFinish={onSubmit}
      onFinishFailed={() => {
        onFinishFailed();
      }}
      onValuesChange={() => {
        onValuesChange(false);
      }}
      initialValues={initialValues}
      autoComplete={detectAutoDetect()}
      layout="vertical"
      className="drawerForm"
    >
      <FuelForm defaultDisplayStep={true} />
    </Form>
  );
};

export default FuelBills;
